import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";

function init() {
}

function populateSiteInformation(siteIds) {
    dataaccess.get({ url: "/Home/Sites?siteIds=" + siteIds }).done(function(res) {
        $("#site-information").html(res);
    });
}

export const homeDashboard = {
    init,
    populateSiteInformation: populateSiteInformation
};